// extracted by mini-css-extract-plugin
export default {"btn":"button-module--btn--sx20t","purple":"button-module--purple--t3ijN","yellow":"button-module--yellow--RwlWv"};